import * as t from 'io-ts'

export const CoordinateC = t.type({
  lat: t.number,
  lng: t.number
})

export const GeoLocationC = t.type({
  type:t.string,
  coordinates:t.readonlyArray(t.number)
})

export type Coordinate = t.TypeOf<typeof CoordinateC>

export type Miles = number

// Adapted from https://cloud.google.com/blog/products/maps-platform/how-calculate-distances-map-maps-javascript-api
export const haversineDistance =
  (mk1: Coordinate) =>
  (mk2: Coordinate): Miles => {
    const R = 3958.8 // Radius of the Earth in miles
    const rlat1 = mk1.lat * (Math.PI / 180) // Convert degrees to radians
    const rlat2 = mk2.lat * (Math.PI / 180) // Convert degrees to radians
    const difflat = rlat2 - rlat1 // Radian difference (latitudes)
    const difflon = (mk2.lng - mk1.lng) * (Math.PI / 180) // Radian difference (longitudes)
    const d =
      2 *
      R *
      Math.asin(
        Math.sqrt(
          Math.sin(difflat / 2) * Math.sin(difflat / 2) +
            Math.cos(rlat1) *
              Math.cos(rlat2) *
              Math.sin(difflon / 2) *
              Math.sin(difflon / 2),
        ),
      )

    return d
  }
